<template>
	<section class="item">

		<div class="inner">

			<img :srcset="sourceSet" :src="'/storage/images/'+option.image" :alt="option.title">

			<h2>{{option.title}}</h2>
            <p v-if="option.description">{{option.description}}</p>

			<ws-popup class="margin-tb-15" popup-title="Allergener" v-if="option.tags.length > 0">

				<section class="pop-inner">

					<ul>
	                    <li v-for="tag in option.tags">
	                        <img :src="tag.icon_path" :alt="tag.name">
	                        {{tag.name}}
	                    </li>
	                </ul>

				</section>

            </ws-popup>

            <div class="price">

				<h3 v-if="asExtra">{{stripeAmount(option.as_extra_price).amount}},-</h3>
				<h3 v-if="option.premium">+{{stripeAmount(option.price).amount}},-</h3>

			</div>

			<incrementer v-model="quantity" :min="0" :max="orderQuantity" :allowed="checkIfIncrementIsAllowed" :increase="duskIncreaseName" :decrease="duskDecreaseName"></incrementer>

		</div>

	</section>
</template>

<script>
    import {mapGetters} from 'vuex';
    import PlusMinusNumberInput from './../partials/PlusMinusNumberInput.vue';
    export default {
        name: "option-item",
        data(){
          return {
              quantity:0,
              initiated: false,
          }
        },
		props:['option', 'selection', 'asExtra', 'startQuantity'],
        components:{
            'incrementer':PlusMinusNumberInput,
        },
		computed:{
			...mapGetters({
				order:'order',
			}),
            orderQuantity(){
                if(this.asExtra){
                    return 0;
                }
                return this.order.details.quantity;
            },
            sourceSet(){
                return '/storage/images/' + this.option.image_x1 + ' 1x, ' + '/storage/images/' + this.option.image + ' 2x';
            },
            duskIncreaseName(){
			    return this.option.title.replace(/\s/g,'') + 'Increase';
            },
            duskDecreaseName(){
                return this.option.title.replace(/\s/g,'') + 'Decrease';
            }
		},
		methods:{
          	toggle(){
          	    if(!this.asExtra){
          	        return
				}

                this.$store.dispatch('setOptionForExtraSelection', {
                    option:this.option,
                    selection:this.selection,
                });

			},
            getAvailableQuantity(){
                try{
                    let options = [];
                    if(!this.asExtra){
                        options = this.order.details.selections.find(item => item.selection_id == this.selection.id).options;
                    }else {
                        options = this.order.details.extra_selections.find(item => item.extra_selection_id == this.selection.id).options;
                    }

                    const currentOptionQuantity = options.map(option => option.quantity).reduce((acc, cur) => acc + cur);

                    return this.orderQuantity - currentOptionQuantity;

                }catch (e) {
                    return this.orderQuantity;
                }
            },
            checkIfIncrementIsAllowed(){
                if(this.asExtra){
                    return true;
                }

                return this.getAvailableQuantity() > 0;
            }
		},
        watch:{
            quantity(newValue, oldValue){
                if(!this.initiated){
                    return;
                }

                if(!this.asExtra){
                    this.$store.dispatch('setOptionForCustomSelection', {
                        option:{
                            id: this.option.id,
                            quantity: newValue,
                            premium: this.option.premium,
                        },
                        selection:this.selection,
                    });
                }else{
                    this.$store.dispatch('setOptionForCustomExtraSelection', {
                        option:{
                            id: this.option.id,
                            quantity: newValue,
                        },
                        selection:this.selection,
                    });
                }

                this.$emit('input', this.quantity);
            }
        },
        created(){
            this.quantity = this.startQuantity;
            this.initiated = true;
        }
    }
</script>

<style scoped>

</style>
